import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { EMPTY, finalize } from 'rxjs';

let _activeRequest = 0
let _activeRequestKeys = new Set<string>();

export function incrementRequest() {
  _activeRequest++;
  if (_activeRequest === 1) showSpinner()
}

export function decrementRequest() {
  _activeRequest--;
  if (_activeRequest === 0) hideSpinner()
}

export function showSpinner() {
  const spinner = document.getElementById('custom-spinner')
  if (spinner) {
    spinner.hidden = false
  }
}

export function hideSpinner() {
  const spinner = document.getElementById('custom-spinner')
  if (spinner) {
    spinner.hidden = true
  }
}

export const TOAST_LOADING = new HttpContextToken(() => false);
export const SKIP_LOADING = new HttpContextToken(() => false);

export const PeticionApiInterceptor: HttpInterceptorFn = (req, next) => {
  // const toast = inject(ToastService)
  const skipSpinner = req.context.get(SKIP_LOADING);
  const useToast = req.context.get(TOAST_LOADING);

  if(skipSpinner || useToast) {
    return next(req);
  }

  const isFormData = req.body instanceof FormData;
  const key = req.method + req.urlWithParams + JSON.stringify(req.body ?? {});
  if (!isFormData) {
    if (_activeRequestKeys.has(key)) {
      return EMPTY;
    }
    _activeRequestKeys.add(key);
  }

  if (_activeRequest == 0) {
    showSpinner()
  }
  _activeRequest++

  return next(req).pipe(
    finalize(() => {
      if (!isFormData) _activeRequestKeys.delete(key);
      _activeRequest--
      if (_activeRequest == 0) {
        hideSpinner()
      }
    })
  )

  // if (!skipSpinner && _activeRequest === 0) {
  //   showSpinner();
  // }

  // if (!skipSpinner) {
  //   _activeRequest++;
  // }

  // let toastId: number | null = null;

  // if (useToast) {
  //   toastId = toast.showLoading('Cargando reporte...', 'Por favor espere')
  // }

  // return next(req).pipe(
  //   finalize(() => {
  //     if (!skipSpinner) {
  //       _activeRequest--;
  //       if (_activeRequest === 0) hideSpinner();
  //     }

  //     if (useToast && toastId !== null) {
  //       toast.updateProgress(toastId, 100);
  //       toast.remove(toastId);
  //     }
  //   })
  // )
}